import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StatItem, StatKey, AjutoareStatsDialogData } from '../ajutoare-stats.types';

@Component({
    selector: 'app-ajutoare-stats-modal',
    templateUrl: './ajutoare-stats-modal.component.html',
    styleUrls: ['./ajutoare-stats-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AjutoareStatsModalComponent {
    constructor(
        public dialogRef: MatDialogRef<AjutoareStatsModalComponent, StatKey | undefined>,
        @Inject(MAT_DIALOG_DATA) public data: AjutoareStatsDialogData
    ) {}

    get totalLabel(): string {
        return this.data.totalCount === 1 ? 'cerere' : 'cereri';
    }

    get relativeUpdate(): string {
        if (!this.data.lastUpdated) return '';
        const diffMs = Date.now() - this.data.lastUpdated.getTime();
        const diffMin = Math.floor(diffMs / 60000);
        if (diffMin < 1) return 'acum câteva secunde';
        if (diffMin === 1) return 'acum 1 minut';
        if (diffMin < 60) return `acum ${diffMin} minute`;
        const diffHours = Math.floor(diffMin / 60);
        if (diffHours === 1) return 'acum 1 oră';
        return `acum ${diffHours} ore`;
    }

    onItemClick(stat: StatItem): void {
        if (stat.count === 0) return;
        this.dialogRef.close(stat.key);
    }

    onClose(): void {
        this.dialogRef.close();
    }

    trackByKey(_: number, stat: StatItem): string {
        return stat.key;
    }
}
